import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TemplateItem.module.scss';
import Icon from '../Icon/Icon';
import cx from 'classnames';
import Tooltip from '../Tooltip/Tooltip';

const TemplateItem = ({ template, selectedTemplateId, templatesWrapper, handleSelectTemplate }) => {
  const { t } = useTranslation();
  const [isHoverDescription, setIsHoverDescription] = useState(false);

  return (
    <>
      <div
        className={cx(styles.templatesItem, { [styles.selectedTemplatesItem]: template.id === selectedTemplateId })}
        onClick={() => handleSelectTemplate(template.id)}
      >
        <div className={styles.templateImageContainer}>
          <img src={template?.thumbnail} className={styles.templateImage} alt={t('my_video.tools.thumbnail')} />
        </div>
        <div
          className={cx(styles.templateInfoContainer, {
            [styles.selectedTemplateImageContainer]: template?.id === selectedTemplateId,
          })}
        >
          <div
            className={styles.templateInfo}
            onMouseEnter={() => setIsHoverDescription(true)}
            onMouseLeave={() => setIsHoverDescription(false)}
          >
            <span className={styles.templateName}>{template?.title}</span>
            <span className={styles.templateDescription}>{template?.description || 'Empty description'}</span>

            <Tooltip
              text={template?.description}
              isHover={isHoverDescription}
              classNameTooltip={styles.tooltipDescription}
              classNameText={styles.tooltipText}
              wrapperRef={templatesWrapper}
            />
          </div>
          <Icon
            className={styles.templateCheckbox}
            src={template?.id === selectedTemplateId ? 'storyboardCheckboxEnabled' : 'storyboardCheckboxDisabled'}
          />
        </div>
      </div>
    </>
  );
};

export default TemplateItem;
